import * as ACTION_TYPES from "../actions/action_types";

export const initialState = {
  menu: "no items",
};

export const MenuReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.SET_MENU:
      return {
        ...state,
        menu: action.payload,
      };
    case ACTION_TYPES.FAILURE:
      return {
        ...state,
        menu: "FAILURE",
      };
    default:
      return state;
  }
};
